import axios from 'axios';
import BaseApi from './base-api';

class WorkOrdersUsersApi extends BaseApi {
  deleteMember(memberId) {
    return axios
      .delete(`${this.baseUrl}/work_order_users/${memberId}`)
      .then(() => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const workOrdersUsersApi = new WorkOrdersUsersApi();



// WEBPACK FOOTER //
// ./src/services/api/work-orders-users-api.js